import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';

import GroupPlaceholder from '../../../assets/images/group_placeholder.svg';
import ImageApi from '../../../api/image';

const SidebarEventBlock = (props) => {
  const [state, setState] = useState({
    imageUrl: '',
  });

  useEffect(() => {
    if (props.imageUrl) {
      ImageApi.getImage(props.imageUrl).then((imageUrl) => {
        setState({ imageUrl });
      });
    }
  }, []);

  const renderTime = (startTime) => {
    const startDate = moment(startTime);
    const now = moment();

    const date = startDate.isSame(now, 'day') ? 'Today' : startDate.format('Do MMM');
    const time = startDate.format('H:mma');

    return `${date} - ${time}`;
  };

  const { title, startTime, id } = props;
  const { imageUrl } = state;
  const rootClassName = 'sidebar-group-block';

  return (
    <Link
      className={rootClassName}
      to={`/feed/${id}?type=event`}
    >
      <div className={`${rootClassName}-image-holder`}>
        {imageUrl ? (
          <img className={`${rootClassName}-image`} src={imageUrl} alt="group" />
        ) : (
          <img
            className={`${rootClassName}-image ${rootClassName}-image__default`}
            src={GroupPlaceholder}
            alt=""
          />
        )}
      </div>

      <div className={`${rootClassName}-title-block`}>
        <p className={`${rootClassName}-title ${rootClassName}-event-title`}>{title}</p>
        <p className={`${rootClassName}-subtitle`}>{renderTime(startTime)}</p>
      </div>
    </Link>
  );
};

export default SidebarEventBlock;
